// 現在の作業セッション（レイヤー／非空間データ）を IndexedDB に保存する。
// localStorage では容量が不足しやすいため、テーブル本体は Parquet バッファとして保持する。
import { getDb, getConnection, query } from '../duckdb/db'

const DB_NAME = 'web-gis-agent'
const STORE_NAME = 'session-tables'
const DB_VERSION = 1

function openStorage() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)
    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_NAME)) db.createObjectStore(STORE_NAME)
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

async function runTransaction(mode, action) {
  if (typeof indexedDB === 'undefined') return null
  const db = await openStorage()
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, mode)
      const request = action(tx.objectStore(STORE_NAME))
      request.onsuccess = () => resolve(request.result)
      request.onerror = () => reject(request.error)
      tx.onabort = () => reject(tx.error)
    })
  } finally {
    db.close()
  }
}

function key(kind, id) {
  return `${kind}:${id}`
}

async function exportTable(tableId) {
  const db = await getDb()
  await getConnection()
  const fileName = `session_${crypto.randomUUID()}.parquet`
  await query(`COPY "${tableId}" TO '${fileName}' (FORMAT PARQUET);`)
  const buffer = await db.copyFileToBuffer(fileName)
  try {
    await db.dropFile(fileName)
  } catch {
    // 仮想ファイルの後始末失敗は保存結果に影響しない。
  }
  return buffer
}

export async function saveSessionTable(kind, id, meta) {
  try {
    const buffer = await exportTable(id)
    await runTransaction('readwrite', (store) =>
      store.put({ kind, id, meta, buffer, savedAt: new Date().toISOString() }, key(kind, id)),
    )
  } catch (error) {
    console.warn(`セッションの保存に失敗しました: ${id}`, error)
  }
}

export async function removeSessionTable(kind, id) {
  try {
    await runTransaction('readwrite', (store) => store.delete(key(kind, id)))
  } catch (error) {
    console.warn(`セッション保存の削除に失敗しました: ${id}`, error)
  }
}

export async function loadSessionTables(kind) {
  try {
    const records = (await runTransaction('readonly', (store) => store.getAll())) ?? []
    return records.filter((record) => record.kind === kind)
  } catch (error) {
    console.warn('セッションの読み込みに失敗しました', error)
    return []
  }
}

export async function restoreSessionTable(record) {
  const db = await getDb()
  await getConnection()
  const fileName = `restore_${crypto.randomUUID()}.parquet`
  await db.registerFileBuffer(fileName, new Uint8Array(record.buffer))
  try {
    await query(`CREATE TABLE "${record.id}" AS SELECT * FROM read_parquet('${fileName}');`)
  } finally {
    try {
      await db.dropFile(fileName)
    } catch {
      // 無視
    }
  }
}

export async function clearSessionStorage() {
  try {
    await runTransaction('readwrite', (store) => store.clear())
  } catch (error) {
    console.warn('セッション保存の初期化に失敗しました', error)
  }
}
